import { useEffect } from "react";
import TimeInput from "react-time-picker-input";
import "react-time-picker-input/dist/components/TimeInput.css";
import "../../src/assets/css/commoncontrol.css";

const CustomTimePicker = (props) => {
    const {
        filedvalue,
        isDisable,
        handleOnChange,
        classid
    } = props

    const handleTimeChange = (e) => {
        handleOnChange(e);
    }

    useEffect(() => {
        if (isDisable) {
            const disablecolor = document.getElementsByClassName("react-time-input-picker-wrapper");

            for (const box of disablecolor) {
                // ✅ Add multiple classes
                box.classList.add("changecolor");

            }
        }
        else {
            const disablecolor = document.getElementsByClassName("react-time-input-picker-wrapper");

            for (const box of disablecolor) {
                // ✅ Add multiple classes
                box.classList.remove("changecolor");

            }
        }
    }, [isDisable]);

    return (
        <div className="text-container">
            <TimeInput id={classid} className="" value={filedvalue} disabled={isDisable ? true : false} allowDelete onChange={handleTimeChange} eachInputDropdown />

        </div>
    );
}
export default CustomTimePicker;
